import * as React from 'react'
import { connect } from 'react-redux'
import Container from '../components/layout/Container'
import Page from '../components/layout/Page'
import { ApplicationState } from '../store'
import { Loading } from '../components/data/Loading'
import { Services } from '../components/services'
import { ErrorPage } from '../components/data/ErrorPage'
import { GoBackButton } from '../components/layout/GoBackButton'
import { RouteType } from '../types/routes'
import { useLoadSalonData } from '../hooks/useLoadSalonData'

interface PropsFromState {
  loading: boolean
  errors?: string
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState

const ServicesPage: React.FC<AllProps> = ({ loading, errors }) => {
  useLoadSalonData({ redirectTo: RouteType.Home })

  if (errors) return <ErrorPage errors={errors} />

  return (
    <Page>
      <Container>
        {loading ? (
          <Loading />
        ) : (
          <>
            <GoBackButton title="Mitarbeiter" />
            <Services />
          </>
        )}
      </Container>
    </Page>
  )
}

const mapStateToProps = ({ services }: ApplicationState) => ({
  loading: services.loading,
  errors: services.errors
})

export default connect(mapStateToProps)(ServicesPage)
